
    import './styles.scoped.css';
    export default {
  "annotation": "awsui_annotation_1hpp3_xp08i_9",
  "next-button": "awsui_next-button_1hpp3_xp08i_10",
  "previous-button": "awsui_previous-button_1hpp3_xp08i_11",
  "finish-button": "awsui_finish-button_1hpp3_xp08i_12",
  "header": "awsui_header_1hpp3_xp08i_13",
  "step-counter-content": "awsui_step-counter-content_1hpp3_xp08i_14",
  "content": "awsui_content_1hpp3_xp08i_15",
  "description": "awsui_description_1hpp3_xp08i_19",
  "actionBar": "awsui_actionBar_1hpp3_xp08i_24",
  "stepCounter": "awsui_stepCounter_1hpp3_xp08i_31",
  "divider": "awsui_divider_1hpp3_xp08i_35",
  "hotspot": "awsui_hotspot_1hpp3_xp08i_39",
  "icon": "awsui_icon_1hpp3_xp08i_110"
};
  